import { ServiceFeeInformation } from '@urbanx/agx.campaigns.client/dist/types/Client'
import {
  AgxModal,
  AgxServiceFeeHistoryView,
  AgxSpacer,
} from '@urbanx/agx.ui-components2'

const ServiceFeeHistoryModal = ({
  onClose,
  serviceFeeInformation: serviceFeeInformation,
}: {
  onClose: () => void
  serviceFeeInformation?: ServiceFeeInformation
}) => {
  if (!serviceFeeInformation) return null

  return (
    <AgxModal
      title={'UX Service Fee History'}
      variant={'withDivider'}
      actionButtonContainerStyle={'withoutDivider'}
      content={
        <AgxSpacer padding="xl">
          <AgxServiceFeeHistoryView serviceFee={serviceFeeInformation} />
        </AgxSpacer>
      }
      setIsDialogOpen={onClose}
      type="single"
    />
  )
}

export default ServiceFeeHistoryModal
